module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "mb-5",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group p-3"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    ref: "pass",
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password-input"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), (!!_vm.pass && !_vm.isValidPassword) ? _c('p', {
    ref: "invalidPass",
    staticClass: "error-msg"
  }, [_vm._v("8文字以上の英数字記号で、英文字と数字をそれぞれ1文字以上使ってください")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group p-3"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reInputPass),
      expression: "reInputPass"
    }],
    ref: "reInputPass",
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "re-password-input"
    },
    domProps: {
      "value": (_vm.reInputPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reInputPass = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isMatch) ? _c('p', {
    ref: "reInputPassError",
    staticClass: "error-msg"
  }, [_vm._v("一致していません")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-outline-info btn-lg",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('a', {
    ref: "submit",
    staticClass: "btn btn-primary btn-lg",
    class: _vm.submitStyle,
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("パスワード変更")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('small', [_vm._v("パスワード変更")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      8文字以上の英数字記号で、英文字と数字をそれぞれ1文字以上使って下さい。"), _c('br'), _vm._v("英文字は、大文字・小文字は区別されます。"), _c('br'), _vm._v("利用可能な記号はこちらになります。"), _c('br'), _vm._v(" !\"#$%&@'()*+,-./_ "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-form-label",
    attrs: {
      "for": "password-input"
    }
  }, [_vm._v("新しいパスワード"), _c('span', {
    staticClass: "attention"
  }, [_vm._v("※")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-form-label",
    attrs: {
      "for": "re-password-input"
    }
  }, [_vm._v("同じ新しいパスワードを入力して下さい"), _c('span', {
    staticClass: "attention"
  }, [_vm._v("※")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7a4cb9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/profile/EditPassword.vue
// module id = 357
// module chunks = 1